import { render, staticRenderFns } from "./ByEmployees.vue?vue&type=template&id=0063d38d&lang=pug"
import script from "./ByEmployees.vue?vue&type=script&lang=js"
export * from "./ByEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports